import { extendTheme, Theme } from '@chakra-ui/react'

import { NucbaColorsTheme, colors } from '../colors'
import { NucbaConfigTheme, config } from '../config'
import { NucbaFontsTheme, fonts } from '../fonts'
import { NucbaFontSizesTheme, fontSizes } from '../fontSizes'
import { NucbaStylesTheme, styles } from '../styles'

type BackOfficeOwnProps = {
    colors: NucbaColorsTheme
    styles: NucbaStylesTheme
    fonts: NucbaFontsTheme
    fontSizes: NucbaFontSizesTheme
    config: NucbaConfigTheme
}

type BackOfficeTheme = BackOfficeOwnProps & Partial<Omit<Theme, keyof BackOfficeOwnProps>>

const typedBackOfficeTheme: BackOfficeTheme = {
    colors,
    styles,
    fonts,
    fontSizes,
    config,
}

const backOfficeTheme = extendTheme({ ...typedBackOfficeTheme })

export { backOfficeTheme, BackOfficeTheme }
